import { AxiosError } from 'axios';
import instance from '../config/axios';
import { ProductFormulationResult } from '../interface/interface';

export const getProductFormulation = async (
  accessToken: string,
): Promise<Array<ProductFormulationResult> | number> => {
  try {
    const response = await instance({
      url: '/api/v1/formulation/products',
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  } catch (e) {
    return (e as AxiosError).response!.status;
  }
};
